<template lang="pug">
  v-container
    v-card(:class="cardPosition")
      v-card-title
        h1 Renderer Service Management
      v-card-text
        v-row(v-if="loading")
          v-col
            h2 LOADING...
        v-row(v-else)
          v-col
            h2 CONTROLS
              v-switch(v-model="rendererStatus" :disabled="disableToggle" :label="toggleMessage" @change="toggleRendererService")
          v-col
            div
              h2 
                | COMPILATION STATUS: 
            div.spaced(:class="compilationStatus")
              strong {{ compiling ? "COMPILING..." : "NOT COMPILING" }}
            div
              h2 
                | VIEWS ASEMBLY LOADED: 
            div.spaced(:class="assemblyLoadedStatus")
              strong {{ loadedAssembly ? "YES" : "NO" }}
          v-col(cols="12")
            h2 COMPILED VIEWS: (UIDs)
            span If you cannot find a view in this list, review the code (and simulate) maybe there is a compilation error, if simulation works but you still dont find your ActionTemplate in this list, review you code, possible variables declared more than once (runtime compilation allows this for some reason).
            v-text-field(
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            )
            v-data-table(
              v-if="views.length > 0",
              :items="views",
              :headers="headers",
              :search="search"
            )
            div(v-else) 
              h3.spaced NO VIEWS LOADED...
    div.error(v-if="error")
      span.spaced {{ error }}
</template>
<style scoped>
  .with-error {
    margin-top: 60px;
  }
  .without-error {}
  .relative {
    position: relative;
  }
  .error {
    color: white;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 15px;
  }
  table {
    width: 100%;
  }
  table, th, td {
    padding: 5px;
    border: 1px solid black;
    border-collapse: collapse;
  }
  .spaced {
    padding: 10px;
  }
  .red {
    background-color: red;
    color: black;
  }
  .orange {
    background-color: orange;
    color: black;
  }
  .green {
    background-color: green;
    color: black;

  }
</style>
<script>
import axios from 'axios'
export default {
  data: () => ({
    search: null,
    loading: true,
    compiling: false,
    loadedAssembly: false,
    disableToggle: false,
    rendererStatus: false,
    views: [],
    error: null,
    headers: [
      { text: "No", value: "No" },
      { text: "UID", value: "UID" },
    ]
  }),
  computed: {
    cardPosition() {
      return !!this.error ? 'with-error' : 'without-error'
    },
    compilationStatus() {
      return this.compiling ? "orange" : "green"
    },
    assemblyLoadedStatus() {
      return this.loadedAssembly ? "green" : "red"
    },
    toggleMessage() {
      const defaultLabel = "RENDER SERVICE ENABLE"
      if (this.disableToggle)
        return "SAVING..."
      return defaultLabel;
    }
  },
  watch: {
    error: function(newError, oldError) {
      setTimeout(() => this.showError = false, 5000);
    }
  },
  methods: {
    async toggleRendererService() {
      this.disableToggle = true
      this.rendererStatus = (await axios.get('ATRenderAPIManagement/toggle-renderer-service')).data.precompilationEnabled
      setTimeout(() => {
        this.disableToggle = false
      }, 1000);
    },
    async load() {
      try {
        this.rendererStatus = (await axios.get('ATRenderAPIManagement/renderer-service-enabled-status')).data.precompilationEnabled
        this.loadedAssembly = (await axios.get('ATRenderAPIManagement/views-loaded-render-api')).data == "yes"
        this.compiling = (await axios.get('ATRenderAPIManagement/compilation-status')).data == "Compiling"
        const views = (await axios.get('ATRenderAPIManagement/list-compiled-action-templates')).data
        this.views = [];
        views.forEach((element, i) => {
          this.views.push({ No: i, UID: element })
        });
        this.error = null;
      } catch (err) {
        console.error(err)
        this.error = `${err}`;
      }
    }
  },
  async mounted() {
    await this.load();
    this.loading = false
    setInterval( async () => {
      await this.load()
    }, 5000)
  }
}
</script>